<template>
	<div class="title">
		<h2 class="title__main">
			{{ title }}
			<Icon
				v-if="tooltipIcon"
				v-tooltip="{content: tooltipText, classes: 'tooltip s-html -sm'}"
				:icon-name="tooltipIcon"
			/>
		</h2>
		<h4
			v-if="subtitle"
			class="title__sub"
		>
			{{ subtitle }}
		</h4>
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'Title',
	components: {
		Icon,
	},
	props: {
		title: {
			type:     String,
			required: true,
		},
		subtitle: {
			type:    String,
			default: null,
		},
		tooltipIcon: {
			type:    String,
			default: null,
		},
		tooltipText: {
			type:    String,
			default: null,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

// .title {}

.title__main {
	@include font(primary, medium, normal, fs-120);
	display: flex;
	align-items: center;
	gap: $sp3;
	color: var(--color-grey-300);
}

.title__sub {
	@include font(primary, book, normal, fs-80);
	color: var(--color-grey-500);
}

</style>
